/********************************************
* Image lazy-loading
********************************************/

/**
* Background: 		<div class="lazy" data-bg="url(../img/44721746JJ_15_a.jpg)"></div>
* Image: 			<img class="lazy" data-src="../img/44721746JJ_15_a.jpg">
*/
var dtLazyLoadInstance = null;

function fnInitLazyLoad() {
	if (typeof LazyLoad === 'undefined') {
		return false;
	}

	if (!dtLazyLoadInstance) {
		dtLazyLoadInstance = new LazyLoad({
			elements_selector: '.lazy',
			callback_enter: function (el) {
				$(el).addClass('lazy-loaded');
			},
		});
	} else {
		dtLazyLoadInstance.update();
	}

	return true;
}

/**
 * @deprecated Use fnInitLazyLoad once; kept for ajax re-init hooks.
 */
function fnLazyLoad() {
	return fnInitLazyLoad();
}


// END OF DOCUMENT
